import { ComponentType, lazy, Suspense } from "react";
import { Providers } from "providers/Providers";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./App.css";
import { Box, CircularProgress } from "@mui/material";

const lazyReloadOnFail = (
	fn: () => Promise<{ default: ComponentType<any> } | PromiseLike<{ default: ComponentType<any> }>>,
): Promise<{ default: ComponentType<any> }> => {
	return new Promise(resolve => {
		fn()
			.then(resolve)
			.catch(() => {
				window.location.reload();
			});
	});
};

const UnknownPage = lazy(() => lazyReloadOnFail(() => import("pages/UnknownPage/UnknownPage")));
const ReviewPage = lazy(() => lazyReloadOnFail(() => import("pages/ReviewPage/ReviewPage")));
const CollectionPage = lazy(() =>
	lazyReloadOnFail(() => import("pages/CollectionPage/CollectionPage")),
);

export const App = () => (
	<Providers>
		<BrowserRouter>
			<Suspense
				fallback={
					<Box
						width="100%"
						height="100%"
						display="flex"
						alignItems="center"
						justifyContent="center"
					>
						<CircularProgress />
					</Box>
				}
			>
				<Routes>
					<Route path="/:hash" element={<ReviewPage />} />
					<Route path="/set/:hash" element={<CollectionPage />} />
					<Route path="*" element={<UnknownPage />} />
				</Routes>
			</Suspense>
		</BrowserRouter>
	</Providers>
);
